<div class="modal-header">
  <h6 class="modal-title">
    @if (isEdit()) {
      <ng-container i18n="@@pdc.dashboard_admin.widget.edit_title">Edit widget</ng-container>
    } @else {
      <ng-container i18n="@@pdc.dashboard_admin.widget.add_title">Add widget</ng-container>
    }
  </h6>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">&times;</button>
</div>

<div class="modal-body wem-body">
  @if (error(); as e) {
    <div class="alert alert-danger py-2 px-3 mb-3">{{ e }}</div>
  }

  <div class="wem-field">
    <label for="wem-title" i18n="@@pdc.dashboard_admin.field.title">Title</label>
    <input id="wem-title" type="text" class="form-control form-control-sm" [ngModel]="title()" (ngModelChange)="title.set($event)" />
  </div>

  <div class="row g-3">
    <div class="wem-field col-6">
      <label for="wem-type" i18n="@@pdc.dashboard_admin.field.type">Type</label>
      <select id="wem-type" class="form-select form-select-sm" [ngModel]="widgetType()" (ngModelChange)="widgetType.set($event)">
        @for (t of widgetTypes; track t) { <option [value]="t">{{ t }}</option> }
      </select>
    </div>
    <div class="wem-field col-6">
      <div class="pseudo-label" i18n="@@pdc.dashboard_admin.field.icon">Icon (FontAwesome)</div>
      <icon-picker [value]="icon()" (valueChange)="icon.set($event)"></icon-picker>
    </div>
  </div>

  <div class="row g-3">
    <div class="wem-field col-6">
      <label for="wem-cols" i18n="@@pdc.dashboard_admin.field.columns">Columns (1–12)</label>
      <input id="wem-cols" type="number" min="1" max="12" class="form-control form-control-sm" [ngModel]="cols()" (ngModelChange)="setCols($event)" />
    </div>
    <div class="wem-field col-6">
      <label for="wem-position" i18n="@@pdc.dashboard_admin.field.position">Position</label>
      <input id="wem-position" type="number" min="0" class="form-control form-control-sm" [ngModel]="position()" (ngModelChange)="position.set($event)" />
    </div>
  </div>

  <div class="wem-divider"></div>

  <p class="wem-section-label" i18n="@@pdc.dashboard_admin.field.required_roles">Required roles</p>
  <div class="wem-toggles">
    <div class="form-check form-switch wem-switch">
      <input class="form-check-input" type="checkbox" role="switch" id="wem-role-everyone" [checked]="requiredRoles().length === 0" (change)="setEveryone()" />
      <label class="form-check-label" for="wem-role-everyone" i18n="@@pdc.dashboard_admin.audience.everyone">everyone</label>
    </div>
    <div class="form-check form-switch wem-switch">
      <input class="form-check-input" type="checkbox" role="switch" id="wem-role-admin" [checked]="hasRole('admin')" (change)="toggleRole('admin')" />
      <label class="form-check-label" for="wem-role-admin" i18n="@@pdc.dashboard_admin.audience.admin">admin</label>
    </div>
  </div>

  <div class="wem-divider"></div>

  <div class="wem-field">
    <label for="wem-settings" i18n="@@pdc.dashboard_admin.field.settings">Settings (JSON)</label>
    <textarea id="wem-settings" class="form-control form-control-sm wem-json" rows="10" [ngModel]="settingsJson()" (ngModelChange)="settingsJson.set($event)"></textarea>
  </div>

  @if (settingsDoc(); as doc) {
    <details class="wem-help">
      <summary i18n="@@pdc.dashboard_admin.settings_help.summary">Settings for <code>{{ widgetType() }}</code> — what goes here</summary>
      <p class="wem-help__desc">{{ doc.description }}</p>
      @for (example of doc.examples; track example.label) {
        <p class="wem-help__example-label">{{ example.label }}</p>
        <pre class="wem-help__example">{{ example.json }}</pre>
        <button type="button" class="btn btn-xs btn-light" (click)="insertExample(example.json)" i18n="@@pdc.dashboard_admin.action.insert_example">Insert example</button>
      }
    </details>
  }

  @if (preview(); as p) {
    <div class="wem-preview">
      <div class="wem-preview__label" i18n="@@pdc.dashboard_admin.preview.label">Preview <span>· renders with live data</span></div>
      <div class="wem-preview__stage">
        <pdc-widget-host [config]="p"></pdc-widget-host>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="button-secondary-outlined" (click)="close()"><span i18n="@@pdc.dashboard_admin.action.cancel">Cancel</span></button>
  <button type="button" class="button-secondary" (click)="previewWidget()"><span i18n="@@pdc.dashboard_admin.action.preview">Preview</span></button>
  <button type="button" class="button-secondary" (click)="save()"><span i18n="@@pdc.dashboard_admin.action.save_widget">Save widget</span></button>
</div>
